<template>
  <div>
    <b-tabs vertical pills small>
      <b-tab title="Risk Overview">
        <div class="p-3">
          <RiskOverviewComponent />
        </div>
      </b-tab>
      <b-tab title="OVERALL PREDICTIVE RISK SCORE">
        <div class="p-3">
          <OverallPredictiveRiskScoreComponent />
        </div>
      </b-tab>
      <b-tab title="[ACCOUNT NAME] (INC. SANCTIONS) PREDICTIVE RISK">
        <div class="p-3">
          <PredictiveRiskComponent />
        </div>
      </b-tab>
      <b-tab title="ANTI-BRIBERTY PREDICTIVE RISK">
        <div class="p-3">
          <AntiBriberiyPredictiveRisk />
        </div>
      </b-tab>
      <b-tab title="HUMAN RIGHTS PREDICTIVE RISK">
        <div class="p-3">
          <HumanRightsPredictiveRisk />
        </div>
      </b-tab>
      <b-tab title="LABOUR PREDICTIVE RISK">
        <div class="p-3">
          <LabourPredictiveRisk />
        </div>
      </b-tab>
      <b-tab title="ENVIROMENTAL PREDICTIVE RISK">
        <div class="p-3">
          <EnviromentalPredictiveRisk />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import RiskOverviewComponent from "./riskOverviewComponent.vue";
import OverallPredictiveRiskScoreComponent from "./overallPredictiveRiskScoreComponent.vue";
import PredictiveRiskComponent from "./predictiveRiskComponent.vue";
import AntiBriberiyPredictiveRisk from "./antiBriberiyPredictiveRisk.vue";
import HumanRightsPredictiveRisk from "./humanRightsPredictiveRisk.vue";
import LabourPredictiveRisk from "./labourPredictiveRisk.vue";
import EnviromentalPredictiveRisk from "./enviromentalPredictiveRisk.vue";
export default {
  name: "RiskSummaryTabComponent",
  components: {
    RiskOverviewComponent,
    OverallPredictiveRiskScoreComponent,
    PredictiveRiskComponent,
    AntiBriberiyPredictiveRisk,
    HumanRightsPredictiveRisk,
    LabourPredictiveRisk,
    EnviromentalPredictiveRisk
  },
  data() {
    return {};
  }
};
</script>